module.exports = __webpack_public_path__ + "static/media/1012253.a72612b0.jpg";